import React from 'react';
import '../styles/MaintenancePage.css';

const MaintenancePage = () => {
  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <div className="maintenance-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="#FF6B6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 12V16" stroke="#FF6B6B" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="9" r="0.5" fill="#FF6B6B" stroke="#FF6B6B" strokeWidth="1"/>
          </svg>
        </div>
        <h1 className="maintenance-title">Application Migration in Progress</h1>
        <p className="maintenance-message">
          The application is currently being migrated to production.
        </p>
        <p className="maintenance-submessage">
          Please expect some downtime during this period. We apologize for any inconvenience.
        </p>
        <p className="maintenance-submessage">
          Please use <a href="https://ionis.maersk-digital.net/opportunities" target="_blank" rel="noopener noreferrer">https://ionis.maersk-digital.net/opportunities</a> to access the new tool
        </p>
        <p className="maintenance-submessage">
          Currently Project Portfolio Overview is not available, we are working on it
        </p>
        <div className="maintenance-footer">
          <p>Thank you for your patience.</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
